import React, { useState, useEffect } from "react";
import { config } from "../config/config";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faMailBulk, faPrint} from "@fortawesome/free-solid-svg-icons";

const NotasPorAlumno = () => {
    const [grados, setGrados] = useState([]);
    const [alumnos, setAlumnos] = useState([]);
    const [notas, setNotas] = useState([]);
    const [gradoSeleccionado, setGradoSeleccionado] = useState("");
    const [alumnoSeleccionado, setAlumnoSeleccionado] = useState("");

    useEffect(() => {
        fetch(`${config.apiUrl}/grados`)
            .then(res => res.json())
            .then(setGrados)
            .catch(console.error);
    }, []);

    const handleGradoChange = (e) => {
        const gradoId = e.target.value;
        setGradoSeleccionado(gradoId);
        setAlumnoSeleccionado("");
        setNotas([]);

        if (gradoId) {
            fetch(`${config.apiUrl}/alumnos/grado/${gradoId}`)
                .then(res => res.json())
                .then(setAlumnos)
                .catch(console.error);
        } else {
            setAlumnos([]);
        }
    };

    const handleAlumnoChange = (e) => {
        setAlumnoSeleccionado(e.target.value);
    };

    const handleVerNotas = () => {
        if (alumnoSeleccionado) {
            fetch(`${config.apiUrl}/notas/alumno/${alumnoSeleccionado}`)
                .then(res => res.json())
                .then(setNotas)
                .catch(console.error);
        }
    };

    return (
        <div className="container mt-5">
            <h2>Consultar Notas</h2>

            <div className="row">
                <div className="col-md-6 mb-3">
                    <label htmlFor="grado" className="form-label">Seleccionar Grado:</label>
                    <select id="grado" className="form-control" value={gradoSeleccionado} onChange={handleGradoChange}>
                        <option value="">Seleccione un grado</option>
                        {grados.map(grado => (
                            <option key={grado.grado_id} value={grado.grado_id}>{grado.nombre_grado}</option>
                        ))}
                    </select>
                </div>
                <div className="col-md-6 mb-3">
                    <label htmlFor="alumno" className="form-label">Seleccionar Alumno:</label>
                    <select id="alumno" className="form-control" value={alumnoSeleccionado}
                            onChange={handleAlumnoChange} disabled={!gradoSeleccionado}>
                        <option value="">Seleccione un alumno</option>
                        {alumnos.map(alumno => (
                            <option key={alumno.alumno_id} value={alumno.alumno_id}>{alumno.nombre}</option>
                        ))}
                    </select>
                </div>
            </div>

            {/* Botón para ver notas */}
            <button className="btn btn-primary mt-3" onClick={handleVerNotas} disabled={!alumnoSeleccionado}>
                Ver Notas
            </button>

            {/* Tabla de Notas */}
            {notas.length > 0 && (
                <div className="container mt-5">
                    <h3>Notas Finales</h3>
                    <div className="table-responsive">
                        <table className="table table-dark table-bordered">
                            <thead>
                            <tr>
                                <th>Materia</th>
                                <th className="text-center">1</th>
                                <th className="text-center">2</th>
                                <th className="text-center">3</th>
                                <th className="text-center">4</th>
                                <th colSpan={2} className="text-center">Acciones</th>
                            </tr>
                            </thead>
                            <tbody>
                            {notas.map(nota => (
                                <tr key={nota.nombre_materia}>
                                    <td className="text-left">{nota.nombre_materia}</td>
                                    <td className="text-center">{nota.periodo1}</td>
                                    <td className="text-center">{nota.periodo2}</td>
                                    <td className="text-center">{nota.periodo3}</td>
                                    <td className="text-center">{nota.periodo4}</td>
                                    <td className="text-center">
                                        <button className="btn btn-success btn-sm mr-2">
                                            <FontAwesomeIcon icon={faPrint}/>
                                        </button>
                                    </td>
                                    <td className="text-center">
                                        <button className="btn btn-success btn-sm mr-2">
                                            <FontAwesomeIcon icon={faMailBulk}/>
                                        </button>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </div>
    );
};

export default NotasPorAlumno;
